import { axios } from "@/lib/axios";
import { AxiosResponse } from "axios";

export const apiGetQuestion = (): Promise<AxiosResponse<any, any>> => {
  return axios.get("/param-s/api/v1/parameters/faqs");
};
